import React from 'react';

import { Box, Typography } from '@mui/material';

import { useRecordContext } from 'react-admin';

import { get } from 'react-hook-form';

import { reportTypesDisplayChoices } from '../../../../constants/reportTypes';
import { Actions } from '../../../../constants/actions';
import SelectArrayField from '../../../../customFields/SelectArrayField';

const ReportField = ({
  action,
}: {
  action: Actions;
}) => {
  const record = useRecordContext();
  const attributes = get(record, `permissions.${action}.attributes.type`, []);

  if (!attributes || attributes.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" marginBottom={6}>
      <Typography>Permission restricted to:</Typography>
      <SelectArrayField
        source={`permissions.${action}.attributes.type`}
        choices={reportTypesDisplayChoices}
        size="small"
      />
    </Box>
  );
};

export default ReportField;
